"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.search.placeholder': 'Cerca sessioni di onboarding...',
};
